import Breadcrumb from "@/components/site/Breadcrumb";

/**
 * Slim navy banner used at the top of inner pages (/about, /values, etc).
 * If the page banner also has a background image (e.g. /about), use it with a navy overlay.
 */
export default function PageBanner({ section, breadcrumbs }) {
  const { eyebrow, heading, paragraphs = [], image } = section;
  return (
    <section className="relative overflow-hidden bg-mist-navy text-white">
      {image && (
        <>
          <img src={image} alt="" className="absolute inset-0 h-full w-full object-cover opacity-40" />
          <div
            className="absolute inset-0"
            style={{
              background: "linear-gradient(105deg, rgba(24,40,74,0.92) 0%, rgba(24,40,74,0.80) 100%)",
            }}
          />
        </>
      )}
      <div className="container-mist relative pt-32 pb-16 lg:pt-40 lg:pb-24">
        {breadcrumbs && breadcrumbs.length > 0 && <Breadcrumb items={breadcrumbs} />}
        {eyebrow && <div className="eyebrow mb-4">{eyebrow}</div>}
        {heading && (
          <h1 className="font-display font-bold text-4xl sm:text-5xl lg:text-[56px] xl:text-[64px] leading-[1.05] tracking-[-0.02em] max-w-3xl">
            {heading}
          </h1>
        )}
        <div className="mt-6 gold-divider" />
        {paragraphs[0] && (
          <p className="mt-6 text-base sm:text-lg text-white/75 max-w-2xl leading-relaxed">{paragraphs[0]}</p>
        )}
      </div>
    </section>
  );
}
